export const TRANSCRIPTS_ROUTE = '/transcripts';
export const COURSES_ROUTE = '/courses';
export const DEGREES_ROUTE = '/degrees';
export const SUBSCRIBE_ROUTE = '/subscribe';
export const DASHBOARD_ROUTE = '/';
